export var GET_DISPLAYS_FOR_CAMPAIGN_REQUEST = "campaign/getDisplayForCampaignRequest";
export var GET_DETAIL_CAMPAIGN_REQUEST = "campaign/getDetailCampaignRequest";
export var GET_ALL_CAMPAIGN_REQUEST = "campaign/getAllCampaignRequest";
export var CREATE_CAMPAIGN_REQUEST = "campaign/createCampaignRequest";
export var UPDATE_CAMPAIGN_REQUEST = "campaign/updateCampaignRequest";
export var ASSIGN_DISPLAY_REQUEST = "campaign/assignDisplayRequest";
